module.exports = __webpack_public_path__ + "static/img/14.f7011a1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/5/zh/14.png
// module id = gJQN
// module chunks = 0